/* eslint-disable react-hooks/exhaustive-deps */
/// Contenedor donde mostramos los tabs de los eventos ///

import React, { useState, useEffect, useRef, useContext } from "react";
import { useInView } from "react-intersection-observer";
import Translate from "../../i18n/Translate";

import { I18nContext } from "../../context/I18nProvider";

import api from "../../api/Api";
import SliderEventsButtons from "../../components/Home/SliderEventsButtons";
import SliderEventsContent from "../../components/Home/SliderEventsContent";
import SliderEventsLoader from "../Loaders/SliderEventsLoader";
import { ArrowButtonLeft, ArrowButtonRight } from "../../components/icons";

const SliderEvents = () => {
  const [active, setActive] = useState(0); // Tab activo
  const [events, setEvents] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [sliderEvent, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const { language } = useContext(I18nContext);

  const lang = language; // Por ahora simulamos el idioma
  const sliderEventsRef = useRef(null); // Referencia detectar el scroll

  // Pedimos los datos a la api
  const getData = async () => {
  setEvents({
    loading: true,
    error: null,
  });

  try {
    const response = await api.events.getAll();
    
    const sortEventsByDate = (events) => {
      
      const monthToNumber = (monthStr) => {
        const monthMap = {
          'ENE': 1, 'Enero': 1, 
          'FEB': 2, 'Febrero': 2, 
          'MAR': 3, 'Marzo': 3, 
          'ABR': 4, 'Abril': 4,
          'Mayo': 5, 
          'Junio': 6, 
          'Julio': 7, 
          'AGO': 8, 'AGOSTO': 8, 'Agosto': 8, 
          'SEP': 9, 'SEPT': 9, 'Septiembre': 9, 
          'OCT': 10, 'Octubre': 10, 
          'NOV': 11, 'Noviembre': 11, 
          'DIC': 12, 'Diciembre': 12
        };
        
        
        
        if (monthStr.includes('/')) {
          const months = monthStr.split('/').map(m => m.trim());
          
          const monthNumbers = months.map(m => monthMap[m] || 0).filter(num => num > 0);
          return monthNumbers.length > 0 ? Math.min(...monthNumbers) : 0;
        }
        
        return monthMap[monthStr] || 0;
      };

      return events.sort((a, b) => {
        const yearA = parseInt(a.content.date.year);
        const monthA = monthToNumber(a.content.date.month);
        const yearB = parseInt(b.content.date.year);
        const monthB = monthToNumber(b.content.date.month);
        
        
        if (yearA !== yearB) {
          return yearA - yearB; 
        }
        
        
        return monthA - monthB; 
      });
    };


    const languageData = response.data[lang];
    const sortedEvents = languageData ? sortEventsByDate([...languageData]) : [];

    setEvents({
      loading: false,
      data: sortedEvents,
    });
      } catch (error) {
        setEvents({
          loading: false,
          error: error.message,
        });
      }
    };

  // Detectamos el scroll del contenedor line
  const handleScroll = (e) => {
    e.preventDefault();

    const el = e.target;
    const bottom = el.scrollHeight - el.scrollTop === el.clientHeight;
    const top = el.scrollTop <= 240;

    if (bottom) {
      sliderEventsRef.current.classList.remove("offBottom");
      sliderEventsRef.current.classList.add("offTop");
      sliderEventsRef.current.classList.remove("offMiddle");
    }

    if (!bottom && !top) {
      sliderEventsRef.current.classList.remove("offTop");
      sliderEventsRef.current.classList.remove("offBottom");
      sliderEventsRef.current.classList.add("offMiddle");
    }

    if (top) {
      sliderEventsRef.current.classList.add("offBottom");
      sliderEventsRef.current.classList.remove("offTop");
      sliderEventsRef.current.classList.remove("offMiddle");
    }
  };

  // Cambiamos el tab activo, mediante los botones
  useEffect(() => {
    if (active > events.data.length - 1) setActive(0);
    if (active < 0) setActive(events.data.length - 1);
  }, [active]);

  // Si el idioma cambia, actualizamos los datos
  useEffect(() => {
    getData();
  }, [lang]);

  // Pantalla de carga
  if (events.loading === true) {
    return <SliderEventsLoader />;
  }

  return (
    <section
      ref={sliderEvent}
      className={inView ? "sliderEvents isActive" : "sliderEvents"}
    >
      <h2>
        <Translate langkey="home.events.title" />
      </h2>

      {/* Contendor */}
      <div className="sliderEvents__container">

        <div className="sliderEvents__selector">
          <div
            className={
              events?.data?.length > 3
                ? "sliderEvents__line hideElements offBottom"
                : "sliderEvents__line"
            }
            onScroll={handleScroll}
            ref={sliderEventsRef}
          >
            <button disabled className="sliderEvents__item"></button>

            {events?.data?.map((event, index) => (
              <SliderEventsButtons
                active={active}
                setActive={setActive}
                index={index}
                event={event.button}
                key={index}
              />
            ))}

            <button disabled className="sliderEvents__item"></button>
          </div>
        </div>

        {events?.data?.map((event, index) => (
          <SliderEventsContent
            active={active}
            index={index}
            content={event.content}
            key={index}
          />
        ))}
      </div>
      {/* End Contenedor */}

      {/* Flechas - solo mobile */}
      <div className="sliderEvents__buttons">
        <button
          className="sliderEvents__buttons--left"
          onClick={(e) => setActive(active - 1)}
        >
          <ArrowButtonLeft />
        </button>

        <button
          className="sliderEvents__buttons--right"
          onClick={(e) => setActive(active + 1)}
        >
          <ArrowButtonRight />
        </button>
      </div>
      {/* End Flechas */}
    </section>
  );
};

export default SliderEvents;
